
import * as THREE from 'three';
const state = {
    activeMesh: {},
    activeMeshName: 'Capot001_CAR_PAINT_0',
    cameraPos: new THREE.Vector3(9, 2, 4),
    target: new THREE.Vector3(4, 0, 0),
    shouldUpdate: true
}
export default state;

//Capot001_CAR_PAINT_0
//object005_bod_0